const CONTENTFUL_IMAGE_HOST = 'images.ctfassets.net';

interface ContentfulImageOptions {
  format?: 'avif' | 'jpg' | 'png' | 'webp';
  quality?: number;
  width?: number;
}

export const optimizeContentfulImage = (
  url?: null | string,
  { format = 'webp', quality = 70, width }: ContentfulImageOptions = {}
): string => {
  if (!url?.trim()) return '';

  const trimmed = url.trim();
  const normalized = trimmed.startsWith('//') ? `https:${trimmed}` : trimmed;

  let parsed: URL;
  try {
    parsed = new URL(normalized);
  } catch {
    return trimmed;
  }

  if (parsed.hostname !== CONTENTFUL_IMAGE_HOST) return trimmed;

  parsed.searchParams.set('fm', format);
  parsed.searchParams.set('q', String(quality));
  if (width) parsed.searchParams.set('w', String(width));

  return parsed.toString();
};
